(() => {
  const SORT_OPTIONS = [
    ["relevance", "Best Match"],
    ["created-descending", "Newly Listed"],
    ["price-ascending", "Price : Low to High"],
    ["price-descending", "Price : High to Low"]
  ];

  const optionExists = (value) => SORT_OPTIONS.some(([optionValue]) => optionValue === value);

  const getSearchQuery = () => {
    const query = new URLSearchParams(window.location.search).get("q") || "";
    return query.replace(/[\u00c3\u00c2\u00e2\u00ef\ufffd\u25a1\u2713]/g, "").trim();
  };

  const getCurrentSort = (select) => {
    const sort = new URLSearchParams(window.location.search).get("sort_by") || select?.value || "relevance";
    return optionExists(sort) ? sort : "relevance";
  };

  const hydrateSearchQuery = () => {
    const query = getSearchQuery();
    if (!query) return;

    document.querySelectorAll('input[name="q"]').forEach((input) => {
      if (!(input instanceof HTMLInputElement) || input.type === "hidden") return;
      input.value = query;
      input.setAttribute("value", query);
      input.style.color = "#202830";
      input.style.backgroundColor = "#ffffff";
    });

    document.querySelectorAll(".section-search-template .search-results_title").forEach((title) => {
      const label = title.querySelector(".search-results_title-label");
      const count = title.querySelector(".search-results_title-count");
      if (label) label.textContent = `Search results for "${query}"`;
      if (count) count.textContent = (count.textContent || "").replace(/\s+for\s+".*?"\s*$/i, "").trim();
    });
  };

  const normalizeDropdown = (section) => {
    const select = section.querySelector("[data-search-sort-select]");
    if (!select) return null;

    const currentSort = getCurrentSort(select);
    select.innerHTML = SORT_OPTIONS.map(([value, label]) => (
      `<option value="${value}"${value === currentSort ? " selected" : ""}>${label}</option>`
    )).join("");
    select.value = currentSort;

    if (select.dataset.amtSortMetricsBound !== "true") {
      select.dataset.amtSortMetricsBound = "true";
      select.addEventListener("change", () => {
        const url = new URL(window.location.href);
        if (select.value && select.value !== "relevance") {
          url.searchParams.set("sort_by", select.value);
        } else {
          url.searchParams.delete("sort_by");
        }
        url.searchParams.delete("page");
        window.location.href = url.toString();
      });
    }

    return select;
  };

  const cardInfo = (card, index) => {
    const quoteOnly = Boolean(card.querySelector("[data-amt-quote-only='true'], [data-rfq-open], .btn-rfq-card"));
    const price = Number(card.dataset.amtPrice || card.querySelector("[data-amt-price]")?.dataset.amtPrice || 0);
    const visiblePrice = card.querySelector(".product-price:not(.d-none) .price, .product-price:not(.d-none) .price-sale");
    const hasVisiblePrice = price > 0 && !quoteOnly && Boolean(visiblePrice && /\d/.test(visiblePrice.textContent || ""));
    const available = card.dataset.amtAvailability === "in-stock" && !quoteOnly;
    const title = card.querySelector(".product-card_title a")?.textContent?.trim() || "";
    return { card, index, available, hasVisiblePrice, price, title };
  };

  const sortVisibleCards = (section, sortBy) => {
    const grid = section.querySelector("#main-collection-product-grid");
    if (!grid || !["availability-descending", "title-ascending", "title-descending"].includes(sortBy)) return;

    const cards = Array.from(grid.querySelectorAll(":scope > product-card, :scope > [data-amt-search-boost-product]"));
    if (cards.length < 2) return;

    const sorted = cards.map(cardInfo).sort((a, b) => {
      if (sortBy === "availability-descending") {
        if (a.available !== b.available) return a.available ? -1 : 1;
        if (a.hasVisiblePrice !== b.hasVisiblePrice) return a.hasVisiblePrice ? -1 : 1;
        return a.title.localeCompare(b.title) || a.index - b.index;
      }

      const titleSort = a.title.localeCompare(b.title) || a.index - b.index;
      return sortBy === "title-ascending" ? titleSort : -titleSort;
    });

    sorted.forEach((item) => grid.appendChild(item.card));
  };

  const init = () => {
    hydrateSearchQuery();

    const section = document.querySelector(".section-search-template");
    if (!section) return;

    const select = normalizeDropdown(section);
    const sortBy = getCurrentSort(select);
    sortVisibleCards(section, sortBy);

    const grid = section.querySelector("#main-collection-product-grid");
    if (grid) {
      let pending = false;
      new MutationObserver(() => {
        if (pending) return;
        pending = true;
        window.setTimeout(() => {
          pending = false;
          hydrateSearchQuery();
          normalizeDropdown(section);
          sortVisibleCards(section, getCurrentSort(select));
        }, 0);
      }).observe(grid, { childList: true });
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
